__turbopack_context__.v({
  "confirmWrapper": "tpslModal-module-scss-module__cF3Doa__confirmWrapper",
  "modal": "tpslModal-module-scss-module__cF3Doa__modal",
  "num1": "tpslModal-module-scss-module__cF3Doa__num1",
  "num16": "tpslModal-module-scss-module__cF3Doa__num16",
  "num16Bold": "tpslModal-module-scss-module__cF3Doa__num16Bold",
  "num1Bold": "tpslModal-module-scss-module__cF3Doa__num1Bold",
  "num2": "tpslModal-module-scss-module__cF3Doa__num2",
  "num20": "tpslModal-module-scss-module__cF3Doa__num20",
  "num20Bold": "tpslModal-module-scss-module__cF3Doa__num20Bold",
  "num3": "tpslModal-module-scss-module__cF3Doa__num3",
  "num4": "tpslModal-module-scss-module__cF3Doa__num4",
  "numTitle": "tpslModal-module-scss-module__cF3Doa__numTitle",
  "precision": "tpslModal-module-scss-module__cF3Doa__precision",
  "priceButton": "tpslModal-module-scss-module__cF3Doa__priceButton",
  "priceWrapper": "tpslModal-module-scss-module__cF3Doa__priceWrapper",
  "spinner": "tpslModal-module-scss-module__cF3Doa__spinner",
  "symbolIconPrice": "tpslModal-module-scss-module__cF3Doa__symbolIconPrice",
  "symbolInfo": "tpslModal-module-scss-module__cF3Doa__symbolInfo",
  "title": "tpslModal-module-scss-module__cF3Doa__title",
  "triggerPrice": "tpslModal-module-scss-module__cF3Doa__triggerPrice",
  "triggerPriceWrapper": "tpslModal-module-scss-module__cF3Doa__triggerPriceWrapper",
  "warn": "tpslModal-module-scss-module__cF3Doa__warn",
});
